import { GameManager } from './../../../GameManager';
import { BoardScene } from './../BoardScene';
import { GameConstants } from "../../../GameConstants";
import { GameVars } from "../../../GameVars";
import { Button } from "../../../utils/Utils";
import { AudioManager } from '../../../AudioManager';

export class SettingsLayer extends Phaser.GameObjects.Container {

    private scaledItemsContainer: Phaser.GameObjects.Container;

    constructor(scene: Phaser.Scene) {

        super(scene);

        const darkLayer = new Phaser.GameObjects.Graphics(this.scene);
        darkLayer.fillStyle(0x495471, .7);
        darkLayer.fillRect(0, 0, GameConstants.GAME_WIDTH, GameConstants.GAME_HEIGHT);
        darkLayer.setInteractive(new Phaser.Geom.Rectangle(0, 0, GameConstants.GAME_WIDTH, GameConstants.GAME_HEIGHT), Phaser.Geom.Rectangle.Contains);
        darkLayer.on("pointerdown", () => {
            BoardScene.currentInstance.hideSettingsLayer();
        }, this);
        this.add(darkLayer);

        this.scaledItemsContainer = new Phaser.GameObjects.Container(this.scene);
        this.scaledItemsContainer.x = GameConstants.GAME_WIDTH / 2;
        this.scaledItemsContainer.y = GameConstants.GAME_HEIGHT / 2;
        this.scaledItemsContainer.scaleX = GameVars.scaleX;
        this.add(this.scaledItemsContainer);

        const howToPlayButton = new Button(this.scene, 0, -50, "texture_atlas_5_" + GameVars.gameData.language, "btn_tutorial", "btn_tutorial_on");
        howToPlayButton.onUp(this.onClickHowToPlay, this);
        this.scaledItemsContainer.add(howToPlayButton);

        const restartButton = new Button(this.scene, 0, 50, "texture_atlas_5_" + GameVars.gameData.language, "btn_restart", "btn_restart_on");
        restartButton.onUp(this.onClickRestart, this);
        this.scaledItemsContainer.add(restartButton);
    }

    private onClickHowToPlay(): void {

        AudioManager.playSound("click");

        BoardScene.currentInstance.showTutorialLayer();
        BoardScene.currentInstance.hideSettingsLayer(); 
    }

    private onClickRestart(): void {

        AudioManager.playSound("click");

        GameManager.enterBoardScene(); 
    }
}
